import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="inner f_inner">
        <div className="f_contact">
          <div className="txtbox">
            <p className="tit">
              Contact us<span className="color">.</span>
            </p>
            <p className="desc">
              <strong>상호명:</strong> 바탕에비뉴 주식회사
              <br />
              <strong>대표자:</strong> 조영수, <strong>사업자등록번호:</strong> 269-81-01043
              <br />
              <strong>이메일:</strong>{' '}
              <a href="mailto:batang@ba-tang.com" className="footer_email_link">
                batang@ba-tang.com
              </a>
              , <strong>전화번호:</strong> 02-6673-9493
              <br />
              <strong>통신판매업신고번호:</strong> 2026-서울구로-0069
              <br />
              <strong>사업장 주소:</strong> 서울특별시 구로구 디지털로27가길 17, 7층 702~9호
              <br />
              (구로동, 오닉스 지식산업센터)
            </p>
            <Link to="/inquiry" className="button typeA inq_btn">
              <span className="txt">문의하기</span>
              <img src="/publish/img/webp/btn_arrow.webp" alt="" className="icon" />
            </Link>
          </div>
          <div className="mapbox">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d941.2581105170325!2d126.89170463087136!3d37.48427247670597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9e2254b03b17%3A0xbda9a5d53cb58863!2z7ISc7Jq47Yq567OE7IucIOq1rOuhnOq1rCDrlJTsp4DthLjroZwyN-qwgOq4uCAxNw!5e0!3m2!1sko!2skr!4v1763073404441!5m2!1sko!2skr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="map"
            ></iframe>
          </div>
        </div>
        <div className="f_bottom">
          <div className="leftbox"></div>
          <div className="rightbox">
            <div className="f_nav">
              <Link to="/inquiry" className="link">
                FAQ
              </Link>
              <span className="bar"></span>
              <Link to="/terms?termsOfService=true" className="link">
                이용약관
              </Link>
              {/* <span className="bar"></span>
              <Link to="/terms?refundPolicy=true" className="link">
                환불정책
              </Link> */}
            </div>
            <p className="f_copy">Copyright © 2025 batang avenue co., ltd. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
